import React, { useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, CircularProgress } from '@mui/material';
import { useContent } from '../../../../context/ContentContext';

const BankDetails = ({
    dialogOpen,
    error,
    loading,
    isNewUser,
    formData,
    setFormData,
    handleInputChange,
    handleSubmit,
    handleCloseDialog,
}) => {
    const { BankData } = useContent(); // Destructure BankData from useContent context

    // If you're editing an existing user, populate the form with BankData
    useEffect(() => {
        console.log('Bank data :', BankData)
        console.log('isNewUser:', isNewUser);
        console.log('Form Data after update:', formData);
        if (!isNewUser && BankData) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                bank_name: BankData.bank_name || '',
                bank_account: BankData.bank_account || '',
                name_of_bank_account: BankData.name_of_bank_account || '',
            }));
        }
    }, [isNewUser, BankData, setFormData]);

    return (
        <Dialog open={dialogOpen} onClose={handleCloseDialog}>
            <DialogTitle>{isNewUser ? 'Enter Bank Details' : 'Bank Details'}</DialogTitle>
            <DialogContent>
                {loading ? (
                    <CircularProgress />
                ) : (
                    <>
                        {error && (
                            <div style={{ color: 'red' }}>
                                {Object.keys(error).map((field) => (
                                    <div key={field}>
                                        {Array.isArray(error[field])
                                            ? error[field].map((message, index) => (
                                                <div key={index}>{message}</div>
                                            ))
                                            : <div>{error[field]}</div>}
                                    </div>
                                ))}
                            </div>
                        )}
                        <TextField
                            label="Bank Name"
                            name="bank_name"
                            value={formData.bank_name}
                            onChange={handleInputChange}
                            fullWidth
                            margin="normal"
                            error={!!error?.bank_name}
                            helperText={error?.bank_name?.[0]}
                        />
                        <TextField
                            label="Bank Account"
                            name="bank_account"
                            value={formData.bank_account}
                            onChange={handleInputChange}
                            fullWidth
                            margin="normal"
                            error={!!error?.bank_account}
                            helperText={error?.bank_account?.[0]}
                        />
                        <TextField
                            label="Name of Bank Account"
                            name="name_of_bank_account"
                            value={formData.name_of_bank_account}
                            onChange={handleInputChange}
                            fullWidth
                            margin="normal"
                            error={!!error?.name_of_bank_account}
                            helperText={error?.name_of_bank_account?.[0]}
                        />
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog} variant="outlined" color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSubmit} variant="contained" color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BankDetails;
